"use strict";

class ValidationUtil {
  // 한글 유효성 검증
  krValidation(value) {
    const krReg = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g;
    return krReg.test(value);
  }

  // 숫자 유효성 검증
  numberValidation(value) {
    const verifyNumberReg = /^[0-9]+$/;
    return verifyNumberReg.test(value);
  }

  // 문자 유효성 검증 (한글, 영어)
  characterValidation(value) {
    const generalReg = /[^a-zA-Zㄱ-ㅎㅏ-ㅣ가-힣]/g;
    return generalReg.test(value);
  }

  // 특수 문자를 제외한 문자 유효성 검증
  generalValidation(value) {
    const generalReg = /[^a-zA-Z0-9ㄱ-ㅎㅏ-ㅣ가-힣\u318D\u119E\u11A2\u2022\u2025a\u00B7\uFE55]/g;

    return generalReg.test(value);
  }

  // 특수 문자를 제외한 문자 유효성 검증
  generalValidation2(value) {
    const generalReg = /[^a-zA-Z0-9ㄱ-ㅎㅏ-ㅣ가-힣\s]/g;
    return generalReg.test(value);
  }

  // Email 유효성 검증
  emailValidation(value) {
    const emailReg =
      // eslint-disable-next-line no-control-regex
      /.@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
    // const emailReg = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@([a-zA-Z0-9]+\.)+[a-zA-Z0-9]{2,8}$/i;
    // const emailReg = /^[a-zA-Z0-9+-_.]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
    // const emailReg =/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailReg.test(value);
  }

  // PhoneNumber 유효성 검증
  phoneValidation(value) {
    const phoneReg = /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/;
    return phoneReg.test(value);
  }

  // 집 전화번호 유효성 검증
  homePhoneValidation(value) {
    const phoneReg = /[(0-9)]{30}$/;
    return phoneReg.test(value);
  }

  // 자녀의 PhoneNumber 유효성 검증
  childPhoneValidation(value) {
    const phoneReg = /^01([0|1|6|7|8|9])\d+$/;
    return phoneReg.test(value);
  }

  // 패스워드 유효성 검증
  passwordValidation(value) {
    const passwordReg = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[~!@#$%^&*()_-])[A-Za-z\d~!@#$%^&*()_-]{8,20}$/;
    return passwordReg.test(value);
  }

  // 닉네임 유효성 검증
  // 한글만 입력가능
  mojiNickNameValidation(value) {
    const nickNameReg = /[^ㄱ-ㅎㅏ-ㅣ가-힣]/g;
    return nickNameReg.test(value);
  }

  // 한글 자음/모음만 입력되었는지 검증
  // 자음(ㄱ-ㅎ) 또는 모음(ㅏ-ㅣ)만 있으면 true 반환
  hasIncompleteKorean(value) {
    const incompleteKoreanReg = /[ㄱ-ㅎㅏ-ㅣ]/;
    return incompleteKoreanReg.test(value);
  }
}

const validationUtil = new ValidationUtil();
export default validationUtil;
